var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer",class:{ warning: _vm.minutes < 2 }},[_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.$tr('videoInterview.test.timeRemaining')))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }